import { CategoryGroupUpdatePage } from "@/features/category-group/pages/CategoryGroupUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/$id/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CategoryGroupUpdatePage id={id} />;
}
